import { BrandIcon, Icon } from '@aptuno/aptuno-ui';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useAnalyticsTracker } from '../../../services/analytics';
import { FooterClickedEvent } from './events/footer-clicked.event';
import {
  BrandSection,
  FooterContainer,
  FooterWrapper,
  ItemList,
  ItemName,
  LinksList,
  LinksSection,
  SocialBox,
  SocialButton,
} from './Footer.styled';

const Footer = () => {
  const socialT = useTranslations('socialMedia');
  const footerT = useTranslations('footer');
  const eventTracker = useAnalyticsTracker();

  const FooterSegmentEvents = (labelFooter) => {
    eventTracker.trackEvent(new FooterClickedEvent(labelFooter));
  };

  return (
    <FooterWrapper>
      <FooterContainer>
        <BrandSection>
          <BrandIcon />
          <p>{footerT('messageFooter')}</p>
          <SocialBox>
            <SocialButton>
              <a target="_blank" rel="noopener noreferrer nofollow" href={socialT('facebook')}>
                <Icon icon="facebook-square"></Icon>
              </a>
            </SocialButton>
            <SocialButton>
              <a target="_blank" rel="noopener noreferrer nofollow" href={socialT('instagram')}>
                <Icon icon="instagram-square"></Icon>
              </a>
            </SocialButton>
            <SocialButton>
              <a target="_blank" rel="noopener noreferrer nofollow" href={socialT('linkedin')}>
                <Icon icon="linkedin-square"></Icon>
              </a>
            </SocialButton>
            <SocialButton>
              <a target="_blank" rel="noopener noreferrer nofollow" href={socialT('twitter')}>
                <Icon icon="twitter-square"></Icon>
              </a>
            </SocialButton>
          </SocialBox>
          <p>{footerT('businessName')}</p>
        </BrandSection>
        <LinksSection>
          <LinksList>
            <ItemName>Nosotros</ItemName>
            <ItemList>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="/quienes-somos"
                onClick={() => FooterSegmentEvents('Quiénes Somos')}
              >
                Quiénes Somos
              </a>
            </ItemList>
            <ItemList>
              <a target="_blank" rel="noopener noreferrer" href="/blog" onClick={() => FooterSegmentEvents('Blog')}>
                Blog
              </a>
            </ItemList>
            <ItemList>
              <a target="_blank" rel="noopener noreferrer" href="/ayuda" onClick={() => FooterSegmentEvents('Ayuda')}>
                Ayuda
              </a>
            </ItemList>
            <ItemList>
              <a
                target="_blank"
                rel="noopener noreferrer nofollow"
                href="https://aptuno.bamboohr.com/jobs/"
                onClick={() => FooterSegmentEvents('Trabaja con Nosotros')}
              >
                Trabaja con Nosotros
              </a>
            </ItemList>
          </LinksList>
          <LinksList>
            <ItemName>Equipo</ItemName>
            <ItemList>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={footerT('urlRealStateCompanies')}
                onClick={() => FooterSegmentEvents('Tengo una inmobiliaria')}
              >
                Tengo una inmobiliaria
              </a>
            </ItemList>
            <ItemList>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={footerT('urlAgents')}
                onClick={() => FooterSegmentEvents(footerT('iamAgent'))}
              >
                {footerT('iamAgent')}
              </a>
            </ItemList>
            <ItemList>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="/publicar-inmueble-en-arriendo"
                onClick={() => FooterSegmentEvents('Soy Propietario')}
              >
                Soy Propietario
              </a>
            </ItemList>
            <ItemList>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="/perfil"
                onClick={() => FooterSegmentEvents(footerT('iamTenant'))}
              >
                {footerT('iamTenant')}
              </a>
            </ItemList>
          </LinksList>
          <LinksList>
            <ItemName>Legal</ItemName>
            <ItemList>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="/terminos-y-condiciones"
                onClick={() => FooterSegmentEvents('Términos y Condiciones')}
              >
                Términos y Condiciones
              </a>
            </ItemList>
            <ItemList>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="/politica-de-privacidad"
                onClick={() => FooterSegmentEvents('Política de Privacidad')}
              >
                Políticas de Privacidad
              </a>
            </ItemList>
            <ItemList>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.placetopay.com/web/"
                onClick={() => FooterSegmentEvents('PlaceToPay')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  height: '70px',
                }}
              >
                <Image
                  loader={() => 'https://static.placetopay.com/placetopay-logo-square.svg'}
                  src="https://static.placetopay.com/placetopay-logo-square.svg"
                  height={70}
                  width={70}
                  title="Logo PlaceToPay Aptuno"
                  alt="Logo PlaceToPay Aptuno"
                />
                <Image
                  src="/images/payments-methods/pse.svg"
                  height={25}
                  width={25}
                  title="Logo PSE Aptuno"
                  alt="Logo PSE Aptuno"
                />
                <Image
                  src="/images/payments-methods/american_express.svg"
                  height={25}
                  width={25}
                  title="Logo American Express Aptuno"
                  alt="Logo American Express Aptuno"
                />
                <Image
                  src="/images/payments-methods/diners_club.svg"
                  height={30}
                  width={30}
                  title="Logo Diners Club Aptuno"
                  alt="Logo Diners Club Aptuno"
                />
                <Image
                  src="/images/payments-methods/mastercard.svg"
                  height={30}
                  width={30}
                  title="Logo MasterCard Aptuno"
                  alt="Logo MasterCard Aptuno"
                />
                <Image
                  src="/images/payments-methods/visa.svg"
                  height={30}
                  width={30}
                  title="Logo Visa Aptuno"
                  alt="Logo Visa Aptuno"
                />
              </a>
            </ItemList>
          </LinksList>
        </LinksSection>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer;
